// DS2.4
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { getIconSizeForButtonSize } from '../helpers';
import s from './BuyButton.scss';
const BuyButton = (_param)=>{
    var { size, fillContainerWidth, className, children, icon: IconComponent, postfixIcon: PostFixIconComponent, loading, rounded, variant = 'outline' } = _param, props = _object_without_properties(_param, [
        "size",
        "fillContainerWidth",
        "className",
        "children",
        "icon",
        "postfixIcon",
        "loading",
        "rounded",
        "variant"
    ]);
    const iconSize = getIconSizeForButtonSize(size);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(className, s['root'], s[`size-${size}`], fillContainerWidth && s['fill-container-width'], props.disabled && s['disabled'], loading && s['loading'], rounded && s['rounded'], variant === 'solid' && s['variant-solid'], variant === 'highlighted' && s['variant-highlighted'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children), PostFixIconComponent && /*#__PURE__*/ React.createElement(PostFixIconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }));
};
BuyButton.displayName = 'BuyButton';
export default BuyButton;
